export default "__VITE_ASSET__DSSF6iqI__"